import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, ChevronDownIcon } from 'lucide-react';
import { Button } from '../ui/Button';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [programsDropdownOpen, setProgramsDropdownOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
    setProgramsDropdownOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About',
    path: '/about'
  }, {
    name: 'Testimonials',
    path: '/#testimonials'
  }, {
    name: 'Insights',
    path: '/blog'
  }];
  const programLinks = [{
    name: 'Longevity Program',
    path: '/programs/longevity'
  }, {
    name: 'Corporate Wellness',
    path: '/programs/corporate-wellness'
  }, {
    name: 'Faith & Fitness',
    path: '/programs/faith-fitness'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-black/80 backdrop-blur-xl py-4 border-b border-border' : 'bg-transparent py-6'}`} data-id="element-81">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-82">
        <Link to="/" className="text-gold font-heading text-2xl font-bold tracking-[0.2em] uppercase" data-id="element-83">
          BioShift
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-84">
          {navLinks.slice(0, 2).map(link => <Link key={link.name} to={link.path} className="text-sm font-medium text-white/80 hover:text-gold transition-colors" data-id="element-85">
              {link.name}
            </Link>)}

          {/* Programs Dropdown */}
          <div className="relative group" onMouseEnter={() => setProgramsDropdownOpen(true)} onMouseLeave={() => setProgramsDropdownOpen(false)} data-id="element-86">
            <Link to="/programs" className="flex items-center text-sm font-medium text-white/80 hover:text-gold transition-colors py-2" data-id="element-87">
              Programs
              <ChevronDownIcon className="ml-1 w-4 h-4" data-id="element-88" />
            </Link>

            <div className={`absolute top-full left-0 w-56 bg-surface border border-border shadow-2xl transition-all duration-200 origin-top-left ${programsDropdownOpen ? 'opacity-100 scale-100 visible' : 'opacity-0 scale-95 invisible'}`} data-id="element-89">
              <div className="py-2" data-id="element-90">
                {programLinks.map(link => <Link key={link.name} to={link.path} className="block px-4 py-3 text-sm text-white/80 hover:text-gold hover:bg-white/5 transition-colors" data-id="element-91">
                    {link.name}
                  </Link>)}
              </div>
            </div>
          </div>

          {navLinks.slice(2).map(link => <Link key={link.name} to={link.path} className="text-sm font-medium text-white/80 hover:text-gold transition-colors" data-id="element-92">
              {link.name}
            </Link>)}
        </nav>

        <div className="hidden md:flex items-center space-x-4" data-id="element-93">
          <Link to="/contact" className="text-sm font-medium text-white/80 hover:text-gold transition-colors mr-4" data-id="element-94">
            Contact
          </Link>
          <Button href="https://holistic-health.bioshift.net/calender-booking" size="sm" data-id="element-95">
            Apply Now
          </Button>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-96">
          {mobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-97" /> : <MenuIcon className="w-6 h-6" data-id="element-98" />}
        </button>
      </div>

      {/* Mobile Nav Panel */}
      <div className={`fixed inset-0 bg-dark z-40 transition-transform duration-300 ease-in-out md:hidden ${mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} style={{
      top: '72px'
    }} data-id="element-99">
        <div className="flex flex-col p-6 space-y-6 overflow-y-auto h-full pb-24" data-id="element-100">
          <Link to="/" className="text-lg font-medium text-white hover:text-gold" data-id="element-101">
            Home
          </Link>
          <Link to="/about" className="text-lg font-medium text-white hover:text-gold" data-id="element-102">
            About
          </Link>

          <div className="space-y-4" data-id="element-103">
            <Link to="/programs" className="text-lg font-medium text-white hover:text-gold block" data-id="element-104">
              Programs
            </Link>
            <div className="pl-4 space-y-4 border-l border-border" data-id="element-105">
              {programLinks.map(link => <Link key={link.name} to={link.path} className="block text-white/70 hover:text-gold" data-id="element-106">
                  {link.name}
                </Link>)}
            </div>
          </div>

          <Link to="/testimonials" className="text-lg font-medium text-white hover:text-gold" data-id="element-107">
            Testimonials
          </Link>
          <Link to="/blog" className="text-lg font-medium text-white hover:text-gold" data-id="element-108">
            Insights
          </Link>
          <Link to="/contact" className="text-lg font-medium text-white hover:text-gold" data-id="element-109">
            Contact
          </Link>

          <div className="pt-6 border-t border-border" data-id="element-110">
            <Button href="https://holistic-health.bioshift.net/calender-booking" className="w-full" data-id="element-111">
              Apply Now
            </Button>
          </div>
        </div>
      </div>
    </header>;
}